// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"480":"impressum","792":"main"}[chunkId] + "." + {"480":"6b9bc5e4","792":"b0ae09e6"}[chunkId] + ".css";
};